import { render, staticRenderFns } from "./BuilderList.vue?vue&type=template&id=2a6dfd41"
import script from "./BuilderList.vue?vue&type=script&lang=ts"
export * from "./BuilderList.vue?vue&type=script&lang=ts"
import style0 from "./BuilderList.vue?vue&type=style&index=0&id=2a6dfd41&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports